// index.js 수정 - 테마 관련 로직 제거
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { persistStore } from "redux-persist"; 
import { PersistGate } from "redux-persist/integration/react";
import reducer from './reducer';
import { thunk } from 'redux-thunk';
import logger from 'redux-logger';

// 초기 로딩 화면 제거
const preLoading = document.getElementById('wrapper-pre-loading');
preLoading.remove();

// 스토어 설정
const store = configureStore({
    reducer: reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }).concat(thunk, logger), 
});

export const persistor = persistStore(store);

// 메인 요소 생성
const mainElement = document.createElement('div');
mainElement.id = "csms-studio";
mainElement.style.height = "100vh"; 

const container = document.querySelector('body');
if (container) {
    container.appendChild(mainElement);

    const root = createRoot(mainElement);
    root.render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    );
}